import { readableTextColor as baseReadableTextColor } from '@atlassian/color-picker';

export const readableTextColor = (color: string): string => {
	return baseReadableTextColor(color, '@atlassian/hub-app-shell');
};
